import { Location } from '@angular/common';
import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { CourseExtractQuery, CourseExtractQueryDefaultValues } from 'src/app/components/reporting/course-extract-query';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';
import { ReportingService } from 'src/app/services/reporting.service';

@Component({
    selector: 'app-course-extract',
    templateUrl: './course-extract.component.html',
    styleUrls: ['./course-extract.component.scss'],
    standalone: false
})
export class CourseExtractComponent {

  query: CourseExtractQuery = CourseExtractQueryDefaultValues()
  programs: any[] = []
  pageName = CheckPageAccess.REPORTING
  isLoading = false
  drpDateRangeValue: string = "1";
  hideCustomeDate:boolean=true

  get isPageMode(): boolean {
    return !this.dialogRef;
  }

  constructor(
    private reportservice: ReportingService,
    private progservice: ApplicationProgramsService,
    private location: Location,
    @Optional() private dialogRef: MatDialogRef<CourseExtractComponent> | null
  ) { }

  ngOnInit() {
    this.progservice.getProgramsForUserListing().subscribe({
      next: (data) => {
        this.programs = data
      }
    });

    this.ondrpDateRangeChange();
  }

  generateReport() {
    this.isLoading = true
    setTimeout(() => {
      this.reportservice.getCourseExtract(this.query).subscribe({
        next: (response) => {
          const fileUrl = URL.createObjectURL(response)
          window.open(fileUrl);
        },
        error: (err) => {
          this.isLoading = false
          console.log(err)
        },
        complete: () => {
          this.isLoading = false
        }
      })
    }, 2000)

  }


  ondrpDateRangeChange() {
    let startdate = new Date();
    this.hideCustomeDate = true
    switch (this.drpDateRangeValue) {
      case "1":
        startdate.setDate(startdate.getDate() - 30)
        this.query.StartDate = startdate
        this.query.EndDate = new Date()
        break;
      case "2":
        startdate.setDate(startdate.getDate() - 90)
        this.query.StartDate = startdate
        this.query.EndDate = new Date()
        break;
      case "3":
        startdate.setDate(startdate.getDate() - 365)
        this.query.StartDate = startdate
        this.query.EndDate = new Date()
        break;
      case "4":
        this.hideCustomeDate = false;
        break;
    }
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.location.back();
    }
  }
}
